module.exports = __webpack_public_path__ + "images/shopify-bot6e395f7502627ffd389c46288289d9f8.png";